import { type ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

import styles from './average-index.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { HelpButton } from '@utmb/design-system/help-button/HelpButton';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { VALID_INDEX_THRESHOLD } from '@utmb/utils/utmb-index.constants';

export interface AverageIndexProps {
    /** Final index: average of the 5 retained scores (null when no recent activity). */
    index: number | null;
}

export function AverageIndex({ index }: AverageIndexProps): ReactElement {
    const { t } = useTranslation();

    return (
        <div className={styles.dateIndexDetail}>
            <Font.FuturaMedium color={getColorStyle(ColorTypesEnum.WHITE)} className={styles.average} desktop="24" mobile="14">
                {t('singleRunner.statistics.indexDetail.average')}
            </Font.FuturaMedium>
            {index !== null && index <= VALID_INDEX_THRESHOLD ? (
                <div className={styles.validIndexWrap}>
                    <Font.OxaniumMedium color={getColorStyle(ColorTypesEnum.WHITE)} className={styles.average} desktop="24" mobile="16">
                        {t('singleRunner.statistics.global.validIndex')}
                    </Font.OxaniumMedium>
                    <HelpButton ariaLabel="Aide" isDark>
                        <div className={styles.validIndexHelp}>
                            <Font.FuturaBold desktop="18" mobile="18" as="h2">
                                {t('singleRunner.statistics.global.validIndex')}
                            </Font.FuturaBold>
                            <Font.FuturaBook desktop="14" mobile="14">
                                {t('singleRunner.statistics.global.validIndexLegend')}
                            </Font.FuturaBook>
                        </div>
                    </HelpButton>
                </div>
            ) : (
                <Font.OxaniumMedium color={getColorStyle(ColorTypesEnum.WHITE)} className={styles.average} desktop="48" mobile="32">
                    {index ?? '-'}
                </Font.OxaniumMedium>
            )}
        </div>
    );
}
